import axios from 'axios'
import router from '../router'
import {Toast} from 'vant'
import Qs from 'qs'


const codeMessage = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
    401: '用户没有权限（令牌、用户名、密码错误）。',
    403: '用户得到授权，但是访问是被禁止的。',
    404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的。',
    422: '当创建一个对象时，发生一个验证错误。',
    500: '服务器发生错误，请检查服务器。',
    502: '服务器重启',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。',
};

const baseURL = {
    test: 'http://api.miner.chainck.com/index.php?s=/',
    online: 'https://api.xmi.cash/index.php?s=/',
};


// 创建axios实例
let instance = axios.create({
    timeout: 30000,
    baseURL: baseURL.online,
    headers: {}
});


instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//拦截器
instance.interceptors.request.use((config) => {
    if ('appapi/c2c/get_chat_msgs' !== config.url) {
        // 在发送请求之前做些什么
        Toast.loading({
            duration: 0,
            message: '请稍后...',
        });
    }
    //const store = app._store.getState()
    const token = sessionStorage.getItem("token");
    //如果没有token （登录失效等情况）就跳转路由到登录页面
    if (token) {
        config.headers['Authorization'] = token
    }


    //设置loading显示

    return config
}, (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
})


instance.interceptors.response.use((response) => {
        Toast.clear();

        if (response.data.code !== 1) {
            Toast(response.data.msg);
        }
        if (response.data.code === 403 || response.data.code === 10001) {
            sessionStorage.clear();
            router.push({path: "/login"});
        }
        return response
    },
//// 服务器状态码不是2开头的的情况
    (error) => {
        //loading关掉
        Toast.clear();
        const {response} = error;

        if (response && response.status) {
            let errorText = codeMessage[response.status] || response.statusText
            Toast(errorText);
        } else {
            Toast('请求超时，请刷新重试');

        }
        return Promise.reject(error)
    })


const get = (url, params, config) => {
    return instance.get(
        url,
        {
            params: params,
            ...config
        })
}

const post = (url, data, config) => {
    if (config && config.headers['Content-Type'] === 'multipart/form-data') {
        return instance.post(url, data, config)
    }

    return instance.post(url, Qs.stringify(data), config)

}


export default {
    get,
    post,
    instance
}
